<!--
 * 富文本编辑器组件
 * @author 周琰
 * @time 2023-08-21
 *
-->
<!-- 模板(html)代码 start -->
<template>
  <div class="tinymce-editor">
    <editor
      v-model="content"
      :init="init"
      :disabled="disabled"
      @onClick="onClick"
    >
    </editor>
  </div>
</template>

<script>
import { fun_UploadImg } from "../../api";
import tinymce from "tinymce/tinymce";
import Editor from "@tinymce/tinymce-vue";
import "tinymce/themes/silver/theme";
import "tinymce/plugins/image";
import "tinymce/plugins/link";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/code";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/fullscreen";
import "tinymce/icons/default/icons";
export default {
  components: {
    Editor,
  },
  props: {
    value: {
      type: String,
      required: false,
    },
    triggerChange: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    plugins: {
      type: [String, Array],
      default: "lists image link media table wordcount fullscreen code",
    },
    toolbar: {
      type: [String, Array],
      default:
        "undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | lists link unlink image media table code | removeformat | fullscreen | | importword",
      branding: false,
    },
  },
  data() {
    return {
      //初始化配置
      init: {
        language_url: "static/tinymce/langs/zh_CN.js",
        language: "zh_CN",
        skin_url: "static/tinymce/skins/lightgray",
        height: 300,
        plugins: this.plugins,
        toolbar: this.toolbar,
        branding: false,
        menubar: true,
        paste_data_images: true,
        toolbar_drawer: true,
        images_upload_handler: (blobInfo, success) => {
          const img = "data:image/jpeg;base64," + blobInfo.base64();
          success(img);
        },
        file_picker_types: "media",
        file_picker_callback: function(cb, value, meta) {
          if (meta.filetype == "media") {
            //创建一个隐藏的type=file的文件选择input
            let input = document.createElement("input");
            input.setAttribute("type", "file");
            input.click();
            input.onchange = function() {
              let file = this.files[0];
              if (file.type !== "video/mp4") {
                // 提示错误消息
                Message.error("请上传mp4格式的视频！");
                return;
              }
              let formData;
              formData = new FormData();
              formData.append("file", file);
              // 上传视频
              fun_UploadImg("/wenda/upload", formData).then(res => {
                const { result, data } = res.data;
                if (result) {
                  // 工程名
                  const ctx = "/whebd-server";
                  // 获取地址栏域名
                  let str = location.href.split("/");
                  // 拼接url
                  const url = str[0] + "//" + str[2] + ctx + data;
                  // 回显url
                  cb(url, {
                    title: file.name,
                  });
                }
              });
            };
          }
        },
        //设置默认字体
        setup: function(editor) {
          editor.on('init', function (ed) {
            ed.target.editorCommands.execCommand("fontName", false, "SourceHanSans");
          });
        },
        // 添加扩展配置
        external_plugins: {
          importword: "../../static/importword/plugin.min.js"
        },
        // 预处理函数
        importword_handler: function(editor, files, next) {
          // 获取文件
          const file = files[0];
          // 限制小于100M
          const is100M = file.size / 1024 / 1024 < 100;
          // 判断文件是否小于10MB
          if (!is100M) {
            // 提示错误消息
            Message.error("上传的文件大小不可超过100MB！");
            // 返回
            return false;
          }
          // 获取文件名
          const fileName = file.name;
          // 文件后缀
          var suffix = fileName.substring(fileName.lastIndexOf(".") + 1).toLowerCase();
          // 限制文件格式
          if(suffix !== 'zip' && suffix !== 'pdf' && suffix !== 'docx' && suffix !== 'doc'){
            // 提示错误消息
            Message.error("请上传zip,pdf,word格式文件！");
            return false;
          }
          // editor.execCommand("mceInsertContent", false, `<a href="http://localhost:8103/abm-server/api/download?filePath=1854136363516424194" target="_blank">trustPDF.jsv3.2.0.6.zip</a>`)
          // 创建formData
          let formData = new FormData();
          // 放入文件
          formData.append("file", file);
          // 上传文件
          fun_UploadImg("/cmsUpload", formData).then(res => {
            const { result, data } = res.data;
            if (result) {
              // 回显文件名
              // http://test2.mzxxkj.com/emps-server/upload/article/2024/11/1854070136421584896.mp4
              // 插入a标签
              editor.execCommand("mceInsertContent", false, `<a href="${data.url}" target="_blank">${data.fileName}</a>`)
            }
          });
          // if (file_name.substr(file_name.lastIndexOf(".") + 1) == "docx") {
          //   editor.notificationManager.open({
          //     text: "正在转换中...",
          //     type: "info",
          //     closeButton: false
          //   });
          //   next(files);
          // } else {
          //   editor.notificationManager.open({
          //     text: "目前仅支持docx文件格式，若为doc，请将扩展名改为docx",
          //     type: "warning"
          //   });
          // }
        },
        // 过滤函数
        importword_filter: function(result, insert, message) {
          // 自定义操作部分
          insert(result); //回插函数
        }
      },
      content: this.value,
    };
  },
  mounted() {
    tinymce.init({});
  },
  methods: {
    onClick(e) {
      this.$emit("onClick", e, tinymce);
    },
    // 可以添加一些自己的自定义事件，如清空内容
    clear() {
      this.content = "";
    },
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.content = newValue;
      }
    },
    content(newValue) {
      if (this.content) {
        this.$emit("contentData", newValue);
      }
      if (this.triggerChange) {
        this.$emit("change", newValue);
      } else {
        this.$emit("input", newValue);
      }
    },
  },
};
</script>
